'use strict';

module.exports.directive = [
  FormOptionsDirective];

module.exports.controller = [
  '$scope',
  'FormUtils',
  FormOptionsController];

function FormOptionsDirective() {
  return {
    restrict: 'E',
    template: require('./options.html'),
    scope: {
      model: '='
    },
    controllerAs: 'formOptions',
    bindToController: true,
    controller: 'FormOptionsController'
  }
}

function FormOptionsController($scope, FormUtils) {
  var vm = this;
  var constraints = vm.model ? FormUtils.generateOptionsConstraints(vm.model.type) : null;
  vm.showOptions = false;
  vm.showOption = showOption;

  $scope.$watch(function () {
    return vm.model && vm.model.type;
  }, function (mode) {
    constraints = vm.model ? FormUtils.generateOptionsConstraints(vm.model.type) : null;
  });

  function showOption(optionName) {
    return constraints && constraints[optionName] && constraints[optionName].advancedOption;
  }

  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}


// WEBPACK FOOTER //
// ./src/js/forms/directives/options/FormOptionsDirective.js